module.exports = __webpack_public_path__ + "products-33612c4d/header-image-50dfa2378c7cc1b2bb1a62e1e482461f.png";